<script lang="ts">
  import type { HTMLThAttributes } from "svelte/elements";

  type Props = HTMLThAttributes;

  let { children, class: className, ...rest }: Props = $props();
</script>

<th
  {...rest}
  class={["px-4 py-2.5 text-left font-normal text-nowrap text-foreground-tertiary", className]}
>
  {@render children?.()}
</th>
